import { BLOG_POSTS } from '../ids';
import { InstallLocation } from '../types';
import { formatDescription } from '../utils';
export const ids = BLOG_POSTS;
export const getDefinition = (staticsUrl, t) => ({
    ...BLOG_POSTS,
    installLocation: InstallLocation.Profile,
    social: true,
    numbers: {
        key: 'postsCount',
        default: 0,
    },
    method: 'addSection',
    urlOverride: 'blog-posts',
    visibleForRoles: ['admin', 'blog_writer', 'blog_editor'],
    page: {
        name: t('member-pages.posts.name'),
        shortDescription: t('member-pages.posts.short-description'),
        description: formatDescription({
            text: t('member-pages.posts.description.text'),
            bulletPoints: [
                t('member-pages.posts.description.bullet-point-1'),
                t('member-pages.posts.description.bullet-point-2'),
                t('member-pages.posts.description.bullet-point-3'),
                t('member-pages.posts.description.bullet-point-4'),
            ],
        }),
        iconURL: `${staticsUrl}assets/images/icons/blog-icon.png`,
        origin: t('member-pages.origin'),
        isNew: false,
        screenshots: [
            `${staticsUrl}assets/images/blog-posts/blog-posts.png`,
            `${staticsUrl}assets/images/mobile-blog-posts/mobile-blog-posts.png`,
        ],
    },
});
//# sourceMappingURL=blog-posts.js.map